import GameOptions from '../utils/GameOptions';
import BaseScene from './BaseScene';

export class BootScene extends BaseScene {
	constructor() {
		super({ key: 'BootScene' });
	}

	preload() {
		// Loading bitmap fonts
		GameOptions.fonts.forEach(item => {
			this.load.bitmapFont(item.fontName, item.filePNG, item.fileXML);
		});
	}

	create() {
		this.scene.start('PreloadScene');
	}
}
